export const PR_ACTIONS = {
    GET_PREFERENCE_REQUEST: "GET_PREFERENCE_REQUEST",
    GET_PREFERENCE_SUCCESS: "GET_PREFERENCE_SUCCESS",
    GET_PREFERENCE_FAILURE: "GET_PREFERENCE_FAILURE",
  };
  